import { 
	Typography,
	Paper,
	Toolbar,
	LinearProgress,
	Divider,
	StepButton,
	Step,
	StepLabel,
	Stepper,
	CircularProgress,
	Button 
} from '@material-ui/core';
import StoreIcon from '@material-ui/icons/Store';
import WeekendIcon from '@material-ui/icons/Weekend';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import AirlineSeatIndividualSuiteIcon from '@material-ui/icons/AirlineSeatIndividualSuite';
import HomeIcon from '@material-ui/icons/Home';
import IsEmpty from 'lodash.isempty';
import LaunchIcon from '@material-ui/icons/Launch';
import React, { useEffect, useState } from 'react';
import removeHTML from 'shared/utils/removeHTML';
import { BrowserView, MobileView } from 'react-device-detect';
import { CheckCircle } from '@material-ui/icons';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import locationHelper from 'shared/utils/locationHelper';
import { AnimatedCheckmark } from 'shared/components/AnimatedCheckmark';
import theme from 'shared/themes/storis';
import base64 from 'react-native-base64';
import {
	APP_STATUS_CODE_APPROVED,
	APP_STATUS_CODE_DECLINED,
	APP_STATUS_CODE_PENDING,
	APP_STATUS_CODE_PROCESSING,
} from './constants';
import { PROVIDER_TD_BANK } from '../Shared/constants';
import { setDefaultProvider, setReturnedFromThirdPartySite } from '../../redux/domain/Welcome/creators';
import withRouter from 'shared/utils/WithRouter';

export const styles = {
	bed: {
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			left: '25%',
		},
		bottom: '15px',
		left: '52%',
		position: 'relative',
	},
	chair: {
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			left: '15%',
		},
		bottom: '15px',
		left: '35%',
		position: 'relative',
	},
	couch: {
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			left: '8%',
		},
		bottom: '10px',
		left: '17%',
		position: 'relative',
	},
	exitButton: {
		position: 'absolute',
		right: '20px',
	},
	footerText: {
		paddingTop: '8px',
	},
	headerText: {
		paddingTop: '8px',
	},
	headline: {
		textAlign: 'center',
	},
	completedHeadline: {
		textAlign: 'center',
		color: 'green',
	},
	home: {
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			left: '33%',
		},
		bottom: '15px',
		left: '66%',
		position: 'relative',
	},
	listText: {
		fontSize: '12pt',
		paddingTop: '8px',
		paddingBottom: '8px',
		textAlign: 'center',
	},
	message: {
		marginBottom: '15px',
		padding: '15px 0',
		textAlign: 'center',
	},
	paper: {
		width: '95%',
		maxWidth: '800px',
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '8px',
	},
	paperDiv: {
		padding: '25px',
		marginBottom: '15px',
	},
	statusButtonDiv: {
		textAlign: 'center',
	},
	animationDiv: {
		// display: inline-block,
	},
	animationDivHide: {
		display: 'none',
	},
	checkMark: {
		width: '100%',
	},
	store: {
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			left: '0%',
		},
		bottom: '15px',
		left: '2%',
		position: 'relative',
	},
	stepper: {
		backgroundColor: '#FFFFFF',
		width: '95%',
		height: 'auto',
		maxWidth: '800px',
		marginTop: '8px',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	topButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		flexShrink: '0',
	},
	toolbar: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		position: 'sticky',
		top: '0',
		backgroundColor: '#FFFFFF',
		marginBottom: '8px',
		zIndex: '2',
		fallbacks: {
			position: '-webkit-sticky',
		},
	},
	topText: {
		fontSize: '16pt',
		paddingTop: '8px',
		marginLeft: 'auto',
		marginRight: 'auto',
		display: 'block !important'
	},
	mobileStepIndicator: {
		marginLeft: '16px',
		marginTop: '-8px',
		color: theme.palette.primary.main,
		display: 'inline-block',
		position: 'absolute',
		left: '0',
	},
	circularProgress: {
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	accountNumberText: {
		textAlign: 'center',
		opacity: '0.7',
	},
	nextProviderDiv: {
		textAlign: 'center',
	},
	nextProviderButtonDiv: {
		paddingTop: '8px',
	},
	nextProviderExitButtonDiv: {
		paddingTop: '8px',
	},
	nextProviderText: {
		paddingTop: '8px',
	},
	promoCodes: {
		display: 'table',
		margin: '0px auto',
	},
	promoCodeHeader: {
		align: 'left',
	},
	promoCode: {
		align: 'left',
	},
	headerLogo: {
		height: '100%',
		textAlign: 'center',
		margin: 'auto'
	},
	logoImg: {
		objectFit: 'contain',
		height: '100%',
		width: '100%',
	},
	additionalProviderReviewText: {
		textAlign: 'left',
		display: 'inline-flex',
		alignItems: 'baseline',
	},
	accountNumberCopyButton: {
		marginLeft: '10px',
	},
	additionalProviderReviewCheckbox: {
		transform: 'scale(2)',
		marginRight: '15px',
		marginLeft: '15px',
	},
};

const ColoredLine = () => (
	<hr
		style={{
			backgroundColor: theme.palette.primary.main,
			height: 5,
			border: 'none',
		}}
	/>
);

function AppStatus(props) {
	const [completed, setCompleted] = useState(0);
	const [checkingStatus, setCheckingStatus] = useState(false);
	const [statusChecked, setStatusChecked] = useState(false);
	const [countdown, setCountdown] = useState(5);
	const [url, setUrl] = useState('');
	const [nextProviderApplicationSubmitted, setNextProviderApplicationSubmitted] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(false);
	const [showAdditionalProviderReviewCheckbox, setShowAdditionalProviderReviewCheckbox] = useState(
		false,
	);
	const [formValuesToStoreForNextProvider, setFormValuesToStoreForNextProvider] = useState();

	const {
		classes,
		settings,
		appStatus,
		openExitConfirmModal,
		returnedFromThirdPartySite,
		customerId,
		nextProviderId,
		nextProviderName,
		checkAppStatus,
		asyncId,
		currentProviderId,
		formValues,
		locallyStoredEncodedFormValues,
		nextProviderAutoSubmit,
		setApplicationFormData,
		submitCA,
		previousApplicationValues,
		setCompletedAppStatusFields,
		completedAppStatusTitle,
		completedAppStatusText,
		userConsented,
		setUserConsented,
		defaultProvider,
		additionalProviderReviewCheckboxDisplayed,
		setAdditionalProviderReviewCheckboxDisplayed,
		cfaTraceId,
	} = props;

	const [
		additionalProviderReviewCheckboxChecked,
		setAdditionalProviderReviewCheckboxChecked,
	] = useState(userConsented);
	let proceedToNextProviderIfAvailable = true;

	const handleGoToSiteButtonClick = () => {
		if (buttonDisabled) {
			return;
		}
		setButtonDisabled(true);
		if (url !== undefined) {
			setApplicationFormData(base64.encode(JSON.stringify(formValuesToStoreForNextProvider)));
			window.location.href = url;
		}
	};

	const handleNextProviderButtonClick = () => {
		if (settings) {
			setReturnedFromThirdPartySite(false);
			setCompletedAppStatusFields(
				settings.appStatusSettings.NextProviderCompletedAppStatusTitle,
				settings.appStatusSettings.NextProviderCompletedAppStatusText,
			);
			formValuesToStoreForNextProvider.userConsented = additionalProviderReviewCheckboxChecked;
			formValuesToStoreForNextProvider.defaultProvider = defaultProvider;
			setApplicationFormData(base64.encode(JSON.stringify(formValuesToStoreForNextProvider)));
			setUserConsented(additionalProviderReviewCheckboxChecked);
			props.router.navigate('/TermsAndConditions');
		}
	};

	const handleAdditionalProviderReviewCheckboxChange = () => {
		setAdditionalProviderReviewCheckboxChecked(!additionalProviderReviewCheckboxChecked);
	};

	const autoTransferProgress = () => {
		if (countdown !== 0) {
			// with a progress time of 500ms, add the completed value with
			// (100/desiredSeconds) * (progressTime/1000) = 50/desiredSeconds
			setCountdown(countdown - 1);
		}
		if (url !== undefined && countdown === 1) {
			handleGoToSiteButtonClick();
		}
	};

	const progress = () => {
		let delay;
		let statusUrl;
		if (settings !== undefined) {
			delay =
				returnedFromThirdPartySite === true
					? settings.fieldAndFooterSettings.ApplicationStatusPageSettings.FinanceProviderReturnDelayStatusSeconds
					: settings.fieldAndFooterSettings.ApplicationStatusPageSettings.DelayStatusSeconds;
		} else {
			// only needs this to be set initially before it's propogated
			delay = 10;
		}
		if (completed !== 100) {
			// with a progress time of 500ms, add the completed value with
			// (100/desiredSeconds) * (progressTime/1000) = 50/desiredSeconds
			setCompleted(Math.min(completed + 50 / delay, 100));
		}
		if (completed >= 90 && completed < 100 && !statusChecked) {
			setCheckingStatus(true);
		}
		if (completed >= 100 && appStatus.length > 0) {
			// STORIS should only return the URL one time, so there would only be one applicationStatus response
			// from method 35 that contains a URL if one was sent back since you'd never apply to 2 providers at once
			setCompleted(100);
			statusUrl = appStatus.filter(element => element.url !== '');
			if (statusUrl.length > 0) {
				setUrl(statusUrl[0].url);
			}
		}
	};

	const applicationStatusSection = (element, index) => {
		const providerSettings = settings.appStatusSettings.AppStatusProviderSettings.filter(
			setting => setting.ProviderId === element.providerId,
		)[0];
		if (element.appStatusCode === APP_STATUS_CODE_APPROVED) {
			return (
				<div>
					<Divider />
					<Typography className={classes.topText} align="center" variant="display1">
						{providerSettings.ApprovedTitle}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.ApprovedText),
						}}
						className={classes.headerText}
						align="center"
						variant="subheading"
					/>
					<div>
						<Typography key={`${element.providerName}-${index}`} className={classes.listText}>
							{`${element.providerName}`}
							<br />
						</Typography>
						<Typography
							key={`${element.creditLimit}-${index}`}
							type="headline"
							gutterBottom
							className={classes.completedHeadline}
						>
							{element.creditLimit !== undefined ? `$${element.creditLimit}` : null}
							<br />
						</Typography>
						<Typography
							dangerouslySetInnerHTML={{
								__html: removeHTML(providerSettings.ApprovedFooter),
							}}
							className={classes.footerText}
							align="center"
						/>
						{element.providerId !== PROVIDER_TD_BANK ? (
							<Typography
								key={`${element.financeProviderNbr}-${index}`}
								className={classes.accountNumberText}
							>
								{element.financeProviderNbr
									? `${element.providerName} ${
											providerSettings.ApprovedProviderAccountNumberLabel
										} ${element.financeProviderNbr}`
									: null}
							</Typography>
						) : (
							<Typography
								key={`${element.financeProviderNbr}-${index}`}
								className={classes.accountNumberText}
							>
								{element.financeProviderNbr
									? `${element.providerName} ${
											providerSettings.ApprovedProviderAccountNumberLabel
										} ${element.financeProviderNbr}`
									: null}
								{element.financeProviderNbr ? (
									<input
										type="button"
										className={classes.accountNumberCopyButton}
										color="primary"
										onClick={() => {
											navigator.clipboard.writeText(element.financeProviderNbr);
										}}
										value={providerSettings.ApprovedProviderAccountNumberCopyButtonText}
									/>
								) : null}
								<br />
							</Typography>
						)}
						<Typography
							key={`${element.customerId}-${index}`}
							className={classes.accountNumberText}
						>
							{customerId ? `${providerSettings.STORISCustomerIdLabel} ${customerId}` : null}
						</Typography>
						{element.promoCodes && element.promoCodes.length > 0 ? (
							<div className={classes.promoCodes}>
								<br />
								<Typography className={classes.promoCodeHeader}>
									<strong>{providerSettings.PromotionalPaymentPlansHeader}</strong>
								</Typography>
								<Typography key={`promoCodes-${index}`} className={classes.promoCode}>
									{element.promoCodes.map(promoPlan => (
										<div>
											<Typography
												key={`${element.promoPlan}-${index}`}
												className={classes.promoCode}
											>
												{providerSettings.PromotionalPaymentPlanLabel} {promoPlan.promoCode}
												{' - '}
												{promoPlan.promoCodeDescription}
												<br />
											</Typography>
										</div>
									))}
								</Typography>
								<br />
							</div>
						) : null}
					</div>
				</div>
			);
		} else if (element.appStatusCode === APP_STATUS_CODE_PENDING) {
			return (
				<div>
					<Divider />
					<Typography className={classes.topText} align="center" variant="display1">
						{providerSettings.PendingTitle}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.PendingText),
						}}
						className={classes.headerText}
						align="center"
						variant="subheading"
					/>
					<Typography key={`${element.providerName}-${index}`} className={classes.listText}>
						{element.providerName}
						{element.url !== '' && !returnedFromThirdPartySite ? (
							<div>
								<Button
									variant="contained"
									style={{ bottom: '0.5px', left: '10px' }}
									color="primary"
									onClick={handleGoToSiteButtonClick}
									disabled={buttonDisabled}
								>
									{buttonDisabled
										? providerSettings.PendingSectionGoToSiteButtonClickedText
										: providerSettings.PendingSectionGoToSiteButtonText}
									<LaunchIcon style={{ width: '18px', height: '18px', paddingLeft: '8px' }} />
								</Button>
								<Typography className={classes.listText}>
									{providerSettings.FinanceProviderAutoTransferNotificationText}
									{countdown} seconds
								</Typography>
							</div>
						) : null}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.PendingFooter),
						}}
						className={classes.footerText}
						align="center"
					/>
				</div>
			);
		} else if (element.appStatusCode === APP_STATUS_CODE_PROCESSING) {
			return (
				<div>
					<Divider />
					<Typography className={classes.topText} align="center" variant="display1">
						{providerSettings.PendingTitle}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.PendingText),
						}}
						className={classes.headerText}
						align="center"
						variant="subheading"
					/>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.PendingFooter),
						}}
						className={classes.footerText}
						align="center"
					/>
				</div>
			);
		} else if (element.appStatusCode === APP_STATUS_CODE_DECLINED) {
			return (
				<div>
					<Divider />
					<Typography className={classes.topText} align="center" variant="display1">
						{providerSettings.DeclinedTitle}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.DeclinedText),
						}}
						align="center"
						variant="subheading"
					/>
					<Typography key={`${element.providerName}-${index}`} className={classes.listText}>
						{element.providerName}
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.DeclinedFooter),
						}}
						align="center"
					/>
				</div>
			);
		}
		return null;
	};

	const additionalProviderReviewCheckboxSection = () => {
		const providerSettings = settings.appStatusSettings.AppStatusProviderSettings.filter(
			setting => setting.ProviderId === PROVIDER_TD_BANK,
		)[0];
		return nextProviderId ? (
			<div>
				<Divider />
				<Typography type="body1" component="div">
					<div
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.AdditionalProviderReviewCheckboxLabel),
						}}
					/>
				</Typography>
				<Typography
					type="subheading"
					component="div"
					className={classes.additionalProviderReviewText}
				>
					<input
						type="checkbox"
						checked={additionalProviderReviewCheckboxChecked}
						onChange={handleAdditionalProviderReviewCheckboxChange}
						className={classes.additionalProviderReviewCheckbox}
					/>
					<span
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: removeHTML(providerSettings.AdditionalProviderReviewCheckboxText),
						}}
					/>
				</Typography>
				<div className={classes.nextProviderExitButtonDiv}>
					<Button variant="contained" color="primary" onClick={openExitConfirmModal}>
						EXIT
					</Button>
				</div>
			</div>
		) : null;
	};

	useEffect(() => {
		// Because nothing is listed in the array below, this only gets called once at initial load
		if (settings === undefined && (customerId === undefined || customerId === '')) {
			props.router.navigate('/now');
		} else if (settings) {
			setCountdown(settings.fieldAndFooterSettings.ApplicationStatusPageSettings.FinanceProviderAutoTransferDelayStatusSeconds);
		}
		if (formValues === undefined) {
			// This is a return to CFA from external site because that's the only time that the formValues
			// retrieved from getFormValues would be undefined.
			if (locallyStoredEncodedFormValues !== '') {
				// This would be if the user closes out the CFA and then goes directly back
				// to the URL including the custId, bypassing the welcome screen where they are wiped out.
				// We want to make sure they are the same customer. Someone could manually enter
				// a custId in the URL that is different than the one that the formValues were originally
				// stored for, and we don't want them to be able to then apply for additional credit under
				// the other customer that they were stored for.
				const locallyStoredDecodedFormValues = JSON.parse(
					base64.decode(locallyStoredEncodedFormValues),
				);
				if (locallyStoredDecodedFormValues.customerId !== undefined) {
					proceedToNextProviderIfAvailable =
						locallyStoredDecodedFormValues.customerId === customerId;
					if (locallyStoredDecodedFormValues.applicantAgrees) {
						locallyStoredDecodedFormValues.applicantAgrees = false;
					}
					if (locallyStoredDecodedFormValues.coApplicantAgrees) {
						locallyStoredDecodedFormValues.coApplicantAgrees = false;
					}
					if (currentProviderId && currentProviderId === PROVIDER_TD_BANK) {
						if (locallyStoredDecodedFormValues.applicantAcknowledges) {
							locallyStoredDecodedFormValues.applicantAcknowledges = false;
						}
						if (locallyStoredDecodedFormValues.coApplicantAcknowledges) {
							locallyStoredDecodedFormValues.coApplicantAcknowledges = false;
						}
					}
					if (!defaultProvider && locallyStoredDecodedFormValues.defaultProvider) {
						setDefaultProvider(locallyStoredDecodedFormValues.defaultProvider);
					}
					if (locallyStoredDecodedFormValues.userConsented) {
						setUserConsented(locallyStoredDecodedFormValues.userConsented);
					}
					setFormValuesToStoreForNextProvider(locallyStoredDecodedFormValues);
				} else {
					// If the customerId does not exist in the data, that means the customer only made it
					// as far as the review page and then closed the browser out, then someone may have
					// opened the browser back up and gone straight to the URL including any custId
					// (maybe not the same one). We don't want to be able to use those values to apply with
					// additional lenders
					proceedToNextProviderIfAvailable = false;
				}
			} else {
				// The values don't exist locally and also not in state for the form. This
				// could happen if the user closes out the CFA, went back to welcome screen
				// and then goes back to a previously entered URL including a custId
				// Here we don't want them to be able to apply with another provider
				proceedToNextProviderIfAvailable = false;
			}
		} else {
			const stateFormValuesIncludingCustomerId = formValues;
			stateFormValuesIncludingCustomerId.customerId = customerId;
			if (stateFormValuesIncludingCustomerId.applicantAgrees) {
				stateFormValuesIncludingCustomerId.applicantAgrees = false;
			}
			if (stateFormValuesIncludingCustomerId.coApplicantAgrees) {
				stateFormValuesIncludingCustomerId.coApplicantAgrees = false;
			}
			if (currentProviderId && currentProviderId === PROVIDER_TD_BANK) {
				if (stateFormValuesIncludingCustomerId.applicantAcknowledges) {
					stateFormValuesIncludingCustomerId.applicantAcknowledges = false;
				}
				if (stateFormValuesIncludingCustomerId.coApplicantAcknowledges) {
					stateFormValuesIncludingCustomerId.coApplicantAcknowledges = false;
				}
			}
			setFormValuesToStoreForNextProvider(stateFormValuesIncludingCustomerId);
		}
		setShowAdditionalProviderReviewCheckbox(
			defaultProvider
				? false
				: currentProviderId === PROVIDER_TD_BANK &&
					!userConsented &&
					proceedToNextProviderIfAvailable &&
					!additionalProviderReviewCheckboxDisplayed,
		);
		setAdditionalProviderReviewCheckboxDisplayed(showAdditionalProviderReviewCheckbox);
	}, []);

	useEffect(
		() => {
			const timer = setInterval(progress, 500);
			window.scrollTo(0, 0);
			if (
				nextProviderId &&
				appStatus.length > 0 &&
				nextProviderAutoSubmit === false &&
				nextProviderApplicationSubmitted === false
			) {
				const nextProviderApplicationValues = previousApplicationValues;
				nextProviderApplicationValues.providerId = nextProviderId;
				nextProviderApplicationValues.cfaTraceId = cfaTraceId;
				submitCA(asyncId, nextProviderApplicationValues, '');
				setNextProviderApplicationSubmitted(true);
			}

			return () => {
				clearInterval(timer);
			};
		},
		[completed, appStatus],
	);

	useEffect(
		() => {
			// This gets called when:
			// 1. beginning where checkingStatus=false
			// 2. multiple times while checkingStatus is true and completed > 90 & < 100
			// The code below only gets called once, which is during that 2nd period
			if (checkingStatus && !statusChecked) {
				checkAppStatus(
					asyncId,
					customerId,
					locationHelper.location,
					currentProviderId,
					returnedFromThirdPartySite,
					cfaTraceId,
				);
				setStatusChecked(true);
			}
		},
		[checkingStatus],
	);

	useEffect(
		() => {
			if (url) {
				const autoTransferTimer = setInterval(autoTransferProgress, 1000);

				return () => {
					clearInterval(autoTransferTimer);
				};
			}
			return () => {};
		},
		[url, countdown],
	);

	return settings != null ? (
		<div>
			<div className={classes.buttonToolbar}>
				<Toolbar className={classes.topButtons}>
					<div className={classes.headerLogo}>
						<img alt="logo" id="header-logo-image" className={classes.logoImg} />
					</div>
				</Toolbar>
			</div>
			<Toolbar className={classes.toolbar}>
				<MobileView>
					{completed !== 100 ? (
						<Typography
							type="body1"
							component="div"
							className={classes.mobileStepIndicator}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML('Step 4 of 4'),
							}}
						/>
					) : (
						<Typography
							type="body1"
							component="div"
							className={classes.mobileStepIndicator}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML('Application Completed'),
							}}
						/>
					)}
				</MobileView>
				<Button
					className={classes.exitButton}
					variant="contained"
					color="primary"
					onClick={openExitConfirmModal}
				>
					EXIT
				</Button>
			</Toolbar>
			<BrowserView>
				<Stepper className={classes.stepper} activeStep={3} alternativeLabel>
					<Step key={1}>
						<StepLabel>Personal Information</StepLabel>
					</Step>
					<Step key={2}>
						<StepLabel>Review</StepLabel>
					</Step>
					<Step key={3}>
						<StepLabel>Agreement</StepLabel>
					</Step>
					<Step key={4}>
						<StepButton
							icon={
								completed !== 100 ? (
									<CircularProgress color="primary" size="24px" />
								) : (
									<CheckCircle color="primary" size="24px" />
								)
							}
						>
							<StepLabel>Status</StepLabel>
						</StepButton>
					</Step>
				</Stepper>
			</BrowserView>
			<Paper elevation={6} className={classes.paper}>
				<div className={classes.paperDiv}>
					<div className={completed === 100 ? classes.animationDiv : classes.animationDivHide}>
						<Typography type="headline" gutterBottom className={classes.completedHeadline}>
							{completedAppStatusTitle}
						</Typography>
						<Typography
							type="body1"
							component="div"
							className={classes.message}
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{
								__html: removeHTML(completedAppStatusText),
							}}
						/>
						<ColoredLine />
					</div>
					<div className={classes.animationDiv}>
						<MobileView>
							{completed <= 70 ? (
								<div
									className={completed === 100 ? classes.animationDivHide : classes.animationDiv}
								>
									<Typography type="headline" gutterBottom className={classes.headline}>
										{settings.fieldAndFooterSettings.ApplicationStatusPageSettings.AppStatusTitle}
									</Typography>
									<Typography
										type="body1"
										component="div"
										className={classes.message}
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{
											__html: removeHTML(settings.fieldAndFooterSettings.ApplicationStatusPageSettings.AppStatusText),
										}}
									/>
									<CircularProgress className={classes.circularProgress} size="230px" />
								</div>
							) : (
								<div
									className={completed === 100 ? classes.animationDivHide : classes.animationDiv}
								>
									<Typography type="headline" gutterBottom className={classes.headline}>
										{settings.fieldAndFooterSettings.ApplicationStatusPageSettings.CompletedAppStatusTitle}
										{settings.appStatusSettings.CompletedAppStatusTitle}
									</Typography>
									<Typography
										type="body1"
										component="div"
										className={classes.message}
										// eslint-disable-next-line react/no-danger
										dangerouslySetInnerHTML={{
											__html: removeHTML(settings.appStatusSettings.CompletedAppStatusText),
										}}
									/>
									<AnimatedCheckmark className={classes.checkMark} />
								</div>
							)}
						</MobileView>
						<BrowserView>
							<div className={completed === 100 ? classes.animationDivHide : classes.animationDiv}>
								<Typography type="headline" gutterBottom className={classes.headline}>
									{settings.appStatusSettings.AppStatusTitle}
								</Typography>
								<Typography
									type="body1"
									component="div"
									className={classes.message}
									// eslint-disable-next-line react/no-danger
									dangerouslySetInnerHTML={{
										__html: removeHTML(settings.appStatusSettings.AppStatusText),
									}}
								/>
								{/* Stages */}
								<StoreIcon fontSize="large" className={`animated bounce ${classes.store}`} />
								{completed >= 25 ? (
									<WeekendIcon fontSize="large" className={`animated bounce ${classes.couch}`} />
								) : null}
								{completed >= 45 ? (
									<EventSeatIcon fontSize="large" className={`animated bounce ${classes.chair}`} />
								) : null}
								{completed >= 70 ? (
									<AirlineSeatIndividualSuiteIcon fontSize="large" className={`animated bounce ${classes.bed}`} />
								) : null}
								{completed >= 95 ? (
									<HomeIcon fontSize="large" className={`animated bounce ${classes.home}`} />
								) : null}
								<LinearProgress variant="determinate" value={completed} />
							</div>
						</BrowserView>
					</div>
					<div className={classes.statusButtonDiv}>
						<Typography
							dangerouslySetInnerHTML={{
								__html: removeHTML(settings.appStatusSettings.AppStatusFooter),
							}}
							align="center"
						/>
					</div>
					<div className={classes.appResultsDiv}>
						{appStatus.reverse().map(element => applicationStatusSection(element))}
					</div>
					<div className={classes.nextProviderDiv}>
						{showAdditionalProviderReviewCheckbox && appStatus.length > 0 ? (
							<div>{additionalProviderReviewCheckboxSection()}</div>
						) : null}
						{proceedToNextProviderIfAvailable &&
						nextProviderAutoSubmit &&
						!IsEmpty(nextProviderId) ? (
							<div className={classes.nextProviderDiv}>
								<ColoredLine />
								<Typography
									dangerouslySetInnerHTML={{
										__html: removeHTML(settings.appStatusSettings.NextProviderText),
									}}
									className={classes.nextProviderText}
									align="center"
									variant="subheading"
								/>
								<Typography className={classes.topText} align="center" variant="display1">
									{nextProviderName}
								</Typography>
								<div className={classes.nextProviderButtonDiv}>
									<Button
										variant="contained"
										color="primary"
										onClick={handleNextProviderButtonClick}
										// disabled={
										// 	(showAdditionalProviderReviewCheckbox &&
										//		!additionalProviderReviewCheckboxChecked) === true
										// }
									>
										{settings.appStatusSettings.NextProviderButtonText}
									</Button>
								</div>
								<Typography
									dangerouslySetInnerHTML={{
										__html: removeHTML(settings.appStatusSettings.NextProviderFooter),
									}}
									className={classes.nextProviderText}
									align="center"
								/>
							</div>
						) : null}
						{proceedToNextProviderIfAvailable &&
						!nextProviderAutoSubmit &&
						!IsEmpty(nextProviderId) ? (
							<div className={classes.nextProviderDiv}>
								<Divider />
								<Typography className={classes.topText} align="center" variant="display1">
									{settings.appStatusSettings.NextProviderNotAutoSubmitTitle}
								</Typography>
								<Typography
									dangerouslySetInnerHTML={{
										__html: removeHTML(settings.appStatusSettings.NextProviderNotAutoSubmitText),
									}}
									className={classes.nextProviderText}
									align="center"
									variant="subheading"
								/>
								<Typography
									dangerouslySetInnerHTML={{
										__html: removeHTML(settings.appStatusSettings.NextProviderFooter),
									}}
									className={classes.nextProviderText}
									align="center"
								/>
							</div>
						) : null}
					</div>
				</div>
			</Paper>
		</div>
	) : null;
}

AppStatus.propTypes = {
	appStatus: PropTypes.arrayOf(
		PropTypes.shape({
			providerName: PropTypes.string,
			providerId: PropTypes.int,
			appStatusCode: PropTypes.int,
			appStatusMessage: PropTypes.string,
			url: PropTypes.string,
			creditLimit: PropTypes.int,
		}),
	),
	asyncId: PropTypes.string.isRequired,
	classes: PropTypes.shape({}).isRequired,
	checkAppStatus: PropTypes.func.isRequired,
	customerId: PropTypes.string,
	returnedFromThirdPartySite: PropTypes.bool,
	openExitConfirmModal: PropTypes.func.isRequired,
	currentProviderId: PropTypes.string,
	nextProviderId: PropTypes.string,
	nextProviderName: PropTypes.string,
	formValues: PropTypes.shape({}),
	locallyStoredEncodedFormValues: PropTypes.string,
	setApplicationFormData: PropTypes.func.isRequired,
	nextProviderAutoSubmit: PropTypes.bool.isRequired,
	submitCA: PropTypes.func.isRequired,
	previousApplicationValues: PropTypes.shape({}),
	setCompletedAppStatusFields: PropTypes.func.isRequired,
	completedAppStatusTitle: PropTypes.string,
	completedAppStatusText: PropTypes.string,
	userConsented: PropTypes.bool.isRequired,
	setUserConsented: PropTypes.func.isRequired,
	defaultProvider: PropTypes.string,
	additionalProviderReviewCheckboxDisplayed: PropTypes.bool.isRequired,
	setAdditionalProviderReviewCheckboxDisplayed: PropTypes.func.isRequired,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		coApp: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
		comboFields: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.arrayOf(
					PropTypes.shape({ displayText: PropTypes.string, value: PropTypes.string }),
				),
				PropTypes.number,
			]),
		),
		comboFieldsByValue: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.objectOf(
					PropTypes.shape({
						displayOrder: PropTypes.number,
						fieldName: PropTypes.string,
						displayText: PropTypes.string,
						returnValue: PropTypes.string,
						requiresEmploymentData: PropTypes.bool,
					}),
				),
				PropTypes.number,
			]),
		),
		fieldAndFooterSettings: PropTypes.shape({}),
		appStatusSettings: PropTypes.shape({}),
	}),
};

AppStatus.defaultProps = {
	customerId: undefined,
	settings: undefined,
	appStatus: undefined,
	returnedFromThirdPartySite: false,
	nextProviderId: undefined,
	nextProviderName: undefined,
	currentProviderId: undefined,
	locallyStoredEncodedFormValues: undefined,
	nextProviderAutoSubmit: undefined,
	formValues: undefined,
	previousApplicationValues: undefined,
	completedAppStatusTitle: undefined,
	completedAppStatusText: undefined,
	defaultProvider: undefined,
};

export default withRouter(withStyles(styles, { name: 'AppStatus' })(AppStatus));
